"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBookInspectionEnquiryDetailsDto = instanceOfBookInspectionEnquiryDetailsDto;
exports.BookInspectionEnquiryDetailsDtoFromJSON = BookInspectionEnquiryDetailsDtoFromJSON;
exports.BookInspectionEnquiryDetailsDtoFromJSONTyped = BookInspectionEnquiryDetailsDtoFromJSONTyped;
exports.BookInspectionEnquiryDetailsDtoToJSON = BookInspectionEnquiryDetailsDtoToJSON;
exports.BookInspectionEnquiryDetailsDtoToJSONTyped = BookInspectionEnquiryDetailsDtoToJSONTyped;
var ListingInspectionDetailsDto_1 = require("./ListingInspectionDetailsDto");
/**
 * Check if a given object implements the BookInspectionEnquiryDetailsDto interface.
 */
function instanceOfBookInspectionEnquiryDetailsDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('registrationType' in value) || value['registrationType'] === undefined)
        return false;
    if (!('listingInspection' in value) || value['listingInspection'] === undefined)
        return false;
    return true;
}
function BookInspectionEnquiryDetailsDtoFromJSON(json) {
    return BookInspectionEnquiryDetailsDtoFromJSONTyped(json, false);
}
function BookInspectionEnquiryDetailsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'email': json['email'],
        'registrationType': json['registrationType'],
        'isApproved': json['isApproved'] == null ? undefined : json['isApproved'],
        'listingInspection': (0, ListingInspectionDetailsDto_1.ListingInspectionDetailsDtoFromJSON)(json['listingInspection']),
    };
}
function BookInspectionEnquiryDetailsDtoToJSON(json) {
    return BookInspectionEnquiryDetailsDtoToJSONTyped(json, false);
}
function BookInspectionEnquiryDetailsDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'email': value['email'],
        'registrationType': value['registrationType'],
        'isApproved': value['isApproved'],
        'listingInspection': (0, ListingInspectionDetailsDto_1.ListingInspectionDetailsDtoToJSON)(value['listingInspection']),
    };
}
